/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Select as AntSelect, Switch, Skeleton } from 'antd';
import { useField } from 'formik';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { memo } from 'react';
import './style.scss';
import { getLocalStorage, setLocalStorage, removeDuplicates } from '../../../utils';
import moment from 'moment';

const { Option } = AntSelect;

const DEFAULT_OPTIONS = [];

function Select({
  // children,
  options = DEFAULT_OPTIONS,
  label = '',
  name,
  icon,
  listService,
  listKeys = { nameKey: 'name', nameId: 'id', useKey: 'phoneCode' },
  formik,
  extraQuary = {},
  // dependentService,
  isToggle = false,
  onItemChange,
  scope = '',
  // defaultValue = null,
  setFieldValue,
  // dependency,
  size = 'medium',
  selectOptionGroup = false,
  withCountryCode = false,
  setCountry,
  extraClassName,
  loading: isLoading = false,
  isCustomIcon = false,
  isFormik = true,
  extraLoading = false,
  isErrorToast = true,
  checkEmail = false,
  cityLoader = true,
  searchOrNot = false,
  selectOPtionDefault = false,
  selectOPtionValue = null,
  setData,
  isApiCall = true, //false
  addExtraObj = false,
  isDateFormate = false,
  isOrder = false,
  ...rest
}) {
  let [field, meta, helpers] = useField(name);
  const config = { ...field, ...rest };
  const [isScrollLoader, setIsScrollLoader] = useState(false);

  const [limit, setLimit] = useState(10);
  const [extraLoader, setExtraLoader] = useState(extraLoading);
  const [searchData, setSearchData] = useState('');

  const [state, setState] = useState({
    data: [...options],
    groupData: [...options],
    loading: isLoading,
    count: 0,
  });
  const lastApiCallRef = useRef(0);
  const isFirstLoadRef = useRef(true);
  const debounceTimerRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Ref to track current state data without causing stale closures in useCallback
  const stateRef = useRef({ data: [...options], groupData: [...options] });
  const selectProps = {};

  // Keep stateRef in sync with state so getList can read current data without stale closures
  useEffect(() => {
    stateRef.current = { data: state.data, groupData: state.groupData };
  }, [state.data, state.groupData]);

  useEffect(() => {
    if (listService && isApiCall !== false) {
      getList(listService, { limit: 10, offset: 0 }, false);
    } else if (!listService) {
      setState((prev) => ({ ...prev, data: [...options], groupData: [...options] }));
    }
  }, [isApiCall, listService, JSON.stringify(extraQuary), scope]);

  useEffect(() => {
    if (!listService && options) {
      setState((prev) => ({ ...prev, data: [...options], groupData: [...options] }));
    }
  }, [options]);

  // for loading
  useEffect(() => {
    setExtraLoader(extraLoading);
  }, [extraLoading]);

  const getList = useCallback(
    async (listService, limitQuery, isScroll, search) => {
      const requestId = ++lastApiCallRef.current;
      isFetchingRef.current = true;
      try {
        if (!isScroll) {
          setState((prev) => ({ ...prev, loading: true }));
        } else {
          setIsScrollLoader(true);
        }
        const res = await listService({
          queryParams: {
            ...extraQuary,
            scope: scope,
            ...(limitQuery && limitQuery),
            ...(search && { search }),
          },
          isErrorToast,
        });

        if (requestId !== lastApiCallRef.current) {
          return;
        }

        const rawData = res?.data?.rows || (Array.isArray(res) ? res : []);
        const totalCount = res?.data?.count || res?.count || 0;

        let list = [];
        let groupList = [];
        if (Array.isArray(rawData)) {
          list = [
            ...rawData.map((e) => ({
              ...(!isDateFormate && {
                name: `${e[listKeys?.nameKey]} ${
                  listKeys?.lastNameKey ? e[listKeys?.lastNameKey] : ''
                } ${withCountryCode ? `(${e?.countryCode})` : ''}`,
              }),
              ...(isDateFormate && {
                name: `${moment(e[listKeys?.nameKey]).format('YYYY/MM/DD')} ${
                  listKeys?.jobText ? listKeys?.jobText : ''
                } ${listKeys?.lastNameKey ? e[listKeys?.lastNameKey] : ''} ${
                  withCountryCode ? `(${e?.countryCode})` : ''
                }`,
              }),

              id: e[listKeys?.nameId],
              useKey: e[listKeys?.useKey],
              data: e,
            })),
          ];
        }

        if (setCountry) setCountry(rawData?.[0]);
        if (selectOptionGroup) {
          groupList = [
            ...rawData.map((e) => {
              return {
                label: e[listKeys?.nameKey],
                options: [
                  ...(e[listKeys?.useKey]
                    ? e[listKeys?.useKey]?.map((item) => ({
                        label: item[listKeys?.innerLabel],
                        value: item[listKeys?.nameId],
                      }))
                    : []),
                ],
              };
            }),
          ];
        }
        if (addExtraObj) {
          list = removeDuplicates([addExtraObj, ...list], false, 'no');
        }

        const mergedData = isScroll
          ? removeDuplicates([...stateRef.current.data, ...list], false, 'no', 'id')
          : [...list];
        const mergedGroupData = isScroll
          ? [...stateRef.current.groupData, ...groupList]
          : [...groupList];

        setLocalStorage({ keyName: 'isScrollCount', data: totalCount });

        setState((prev) => ({
          ...prev,
          data: mergedData,
          groupData: mergedGroupData,
          loading: false,
          count: totalCount,
        }));

        if (setData) setData(mergedData);

        setIsScrollLoader(false);
        isFetchingRef.current = false;
        isFirstLoadRef.current = false;
      } catch (err) {
        if (requestId === lastApiCallRef.current) {
          setState((prev) => ({ ...prev, loading: false }));
          setIsScrollLoader(false);
          isFetchingRef.current = false;
          isFirstLoadRef.current = false;
        }
        console.log(err);
      }
    },
    [
      extraQuary,
      scope,
      isErrorToast,
      isDateFormate,
      listKeys,
      withCountryCode,
      setCountry,
      selectOptionGroup,
      addExtraObj,
      setData,
    ]
  );

  if (formik?.values) {
    selectProps.value =
      (rest?.mode === 'multiple' || rest?.mode === 'tags') &&
      !formik.values[field?.name]
        ? undefined
        : formik.values[field?.name]
        ? formik.values[field?.name]
        : undefined;
  }

  if (meta && meta.touched && meta.error) {
    config.error = true;
    config.helperText = meta.error;
  }
  const { data, loading, groupData } = state;

  const handleChangeSelect = (value, ...rest) => {
    if (checkEmail) {
      var validRegex = /^\S+@\S+\.\S+$/;
      const validValues = value.filter((item) => {
        return item.match(validRegex);
      });
      helpers.setValue(validValues);
      return;
    }

    if (isFormik) {
      helpers.setValue(value);
    }

    if (onItemChange) {
      // for phone code only
      let getPhoneCode =
        data && data.filter((e) => e.id === value).map((code) => code.useKey);
      onItemChange(
        value,
        formik,
        Array.isArray(getPhoneCode) && getPhoneCode.length > 0
          ? getPhoneCode
          : undefined,
        rest,
        state?.data
      );
    }
    if (setFieldValue) setFieldValue(value);
  };

  const handleChangeToggle = (value) => {
    helpers.setValue(value ? 'active' : 'inactive');
  };

  const onSearch = (e) => {
    setSearchData(e);
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    if (e?.length > 2 && searchOrNot) {
      debounceTimerRef.current = setTimeout(() => {
        getList(listService, { limit: 10, offset: 0 }, false, e);
      }, 700);
    } else if (e?.length === 0) {
      getList(listService, { limit: 10, offset: 0 }, false);
    }
  };

  let apiLimit = limit;
  const handleScroll = (e) => {
    const { target } = e;
    if (isScrollLoader || isFetchingRef.current) return;

    const isAtBottom =
      Math.ceil(target?.scrollTop + target?.offsetHeight) >= target?.scrollHeight;

    if (!isAtBottom) return;

    let apiCount = getLocalStorage({ keyName: 'isScrollCount' });

    if (apiCount > state.data.length) {
      getList(
        listService,
        {
          limit: 10,
          offset: state.data.length,
        },
        true,
        searchData
      );
    }
  };

  const handleCloseSelect = (open) => {
    if (!open) {
      setSearchData('');
    }
  };

  if (isToggle) {
    return (
      <Form.Item
        className="mb-0"
        label={label}
        // name={name}
        help={meta.error && meta?.error && meta?.touched ? meta.error : ''}
        validateStatus={config.error ? 'error' : 'success'}
      >
        <Switch
          checked={formik?.values[name] === 'active' ? true : false}
          onChange={handleChangeToggle}
          {...rest}
        />
      </Form.Item>
    );
  }

  return (
    <Form.Item
      className={`mb-0 ${extraClassName && extraClassName}`}
      label={label}
      // name={name}
      help={meta.error && meta?.error && meta?.touched ? meta.error : ''}
      validateStatus={config.error ? 'error' : 'success'}
    >
      {icon}
      {selectOptionGroup ? (
        <div style={{ position: 'relative' }} className="selectWrapper">
          {extraLoader || loading ? (
            <Skeleton paragraph={{ rows: 0 }} active />
          ) : (
            <AntSelect
              size={size}
              {...rest}
              {...selectProps}
              onChange={handleChangeSelect}
              loading={loading}
              options={groupData}
              getPopupContainer={(trigger) => trigger.parentElement}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option &&
                option.label &&
                typeof option.label === 'string' &&
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            />
          )}
        </div>
      ) : (
        <div style={{ position: 'relative' }} className="selectWrapper">
          {(extraLoader || (loading && isFirstLoadRef.current)) && cityLoader ? (
            <Skeleton paragraph={{ rows: 0 }} active />
          ) : (
            <AntSelect
              size={size}
              optionFilterProp="children"
              filterOption={
                searchOrNot
                  ? false
                  : (input, option) => {
                      return (
                        option?.title &&
                        ('' + option?.title)
                          ?.toLowerCase()
                          ?.indexOf(input?.toLowerCase()) >= 0
                      );
                    }
              }
              showSearch
              {...rest}
              {...selectProps}
              onChange={handleChangeSelect}
              loading={extraLoader || loading || isScrollLoader}
              getPopupContainer={
                !isOrder ? (trigger) => trigger.parentElement : undefined
              }
              onPopupScroll={handleScroll}
              onSearch={(e) => onSearch(e)}
              className={`${isScrollLoader ? 'disable-search' : ''}`}
              onDropdownVisibleChange={(open) => handleCloseSelect(open)}
            >
              <>
                {selectOPtionDefault && (
                  <Option key={selectOPtionDefault} value={selectOPtionValue}>
                    {selectOPtionDefault}
                  </Option>
                )}
                {data.length > 0 &&
                  data.map((item, key) => (
                    <Option
                      key={item.id || key}
                      value={
                        item.value ||
                        (typeof item?.value === 'boolean' &&
                        item?.value === false
                          ? false
                          : item?.value === 0
                          ? 0
                          : item.id
                          ? item.id
                          : item.value)
                      }
                      title={item.name || item.value}
                      disabled={item?.disabled || false}
                    >
                      <div className="d-flex align-items-center">
                        {isCustomIcon && item.icon ? (
                          <div>{item.icon}</div>
                        ) : null}
                        <div>{item.name || item.value}</div>&nbsp;
                        {item?.chip && (
                          <span className="badge bg-primary">
                            {item?.chipValue || ''}
                          </span>
                        )}
                      </div>
                    </Option>
                  ))}
              </>
            </AntSelect>
          )}
        </div>
      )}
    </Form.Item>
  );
}

export default memo(Select);
